export default __webpack_public_path__ + "static/2.5.2/media/logo_small.36d6b4c0.svg";